import { render, staticRenderFns } from "./Enfermedad.vue?vue&type=template&id=875f1daa&scoped=true&"
import script from "./Enfermedad.vue?vue&type=script&lang=js&"
export * from "./Enfermedad.vue?vue&type=script&lang=js&"
import style0 from "./Enfermedad.vue?vue&type=style&index=0&id=875f1daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875f1daa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLayout,VRow})
